import { render, staticRenderFns } from "./conferenceInfoTab.vue?vue&type=template&id=351507e6&"
import script from "./conferenceInfoTab.vue?vue&type=script&lang=js&"
export * from "./conferenceInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./conferenceInfoTab.vue?vue&type=style&index=0&id=351507e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports